import { withStyles } from '@material-ui/core';
import React from 'react';

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  title: {
    fontSize: theme.headerTextFontSize,
    fontWeight: 600
  },
  trailerCount: {
    color: theme.disableButtonText,
    fontWeight: 600
  }
});

const TrailerConstraints = ({ classes, trailerCounts }) => {
  const getTrailerCountString = (trailers) => {
    const trailersListLength = trailers.length;
    return trailers.map((item, index) => (
      <span key={index}>
        {item.trailerName} <span className={classes.trailerCount}>({item.count})</span>
        {index < trailersListLength - 1 ? ' | ' : ''}
      </span>
    ));
  };
  return (
    <div className={classes.container}>
      <div className={classes.title}>Trailer Input</div>
      <div>LG trailers: {getTrailerCountString(trailerCounts.LG)}</div>
      <div>Non-LG trailers: {getTrailerCountString(trailerCounts.NonLG)}</div>
    </div>
  );
};

export default withStyles(styles)(TrailerConstraints);
